module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f440.4c5a77a8.svg";